import { computed } from "vue";
import store from "@/store";

export default () => {
  const showCollabDialog = computed(() => {
    // @ts-ignore
    return store.state.ui.showCollabDialog;
  });

  const setShowCollabDialog = (value: boolean) => {
    store.commit("ui/setShowCollabDialog", value);
  };

  return {
    showCollabDialog,
    setShowCollabDialog
  };
};
